import styled from 'styled-components'

import { CurrencyNetworkIcon } from '@root/entities/currency/ui'
import { useNetworkLinks } from '@root/entities/network'
import { Truncate } from '@root/shared/ui-kit'

import type { Network } from '@root/entities/network'
import type { TxHash } from '@root/entities/transaction'

type Props = {
  network: Network.Network
  txHash: TxHash
}

export const SnackbarTxHasContent = (props: Props) => {
  const { buildTransactionExplorerLink, openTransactionExplorerLink } =
    useNetworkLinks({ network: props.network })

  return (
    <Root
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        openTransactionExplorerLink(props.txHash)
      }}
      href={buildTransactionExplorerLink(props.txHash)}
    >
      <Truncate start={8} end={9}>
        {props.txHash}
      </Truncate>
      <CurrencyNetworkIcon network={props.network} size={12} />
    </Root>
  )
}

const Root = styled.a`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1ch;
  line-height: normal;

  color: var(--text-11);

  &:hover {
    color: var(--appearance-inv-1);
  }
`
